export default [
  {
    path: '/call-center-overview',
    name: 'call-center-overview',
    component: () => import('@/views/callCenterOverview/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.callCenterOverview',
      navActiveLink: 'call-center-overview',
      resource: 'report-call-center-overview',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.callCenterOverview',
          active: true,
        },
      ],
    },
  },
]
